import React from "react";

const TableCell = (props) => {
        let cell="";
        let val=(props.cell && props.cell.h) || (props.cell && props.cell.w);
        if (val) {    
           cell =<span dangerouslySetInnerHTML={{__html:val}}/>
        }
        if (props.cell && props.cell.l) {
            cell =<a href={props.cell.l.Target} target="_blank" dangerouslySetInnerHTML={{__html:val}}/>
        }    
    return(
        <React.Fragment>
        {cell}
        </React.Fragment>
    )
}

export default TableCell;